export default __webpack_public_path__ + "static/index_reason_golf-21422cedac11ea732bb64cae116fbb5d.png";